import React, {useEffect, useRef} from "react";
import Lottie from "lottie-react";

export default function DisplayLottie({
  animationData,
  className,
  style,
  loop = true,
  speed = 2
}) {
  const wrapRef = useRef(null);
  const lottieRef = useRef(null);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const anim = lottieRef.current;
        if (!anim) return;
        if (entry.isIntersecting) {
          anim.setSpeed(speed);
          anim.play();
        } else {
          anim.pause();
        }
      },
      {threshold: 0.08, rootMargin: "80px"}
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [speed]);

  const handleLoaded = () => {
    const anim = lottieRef.current;
    if (!anim) return;
    anim.setSpeed(speed);
    anim.play();
  };

  return (
    <div ref={wrapRef} className={className || "lottie-player"} style={style}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={loop}
        autoplay
        onDOMLoaded={handleLoaded}
        style={{width: "100%", height: "100%"}}
      />
    </div>
  );
}
